var _style, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _path10, _path11, _polygon2, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse2, _polygon3, _polygon4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse3, _path25, _polygon5, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse4, _path41, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _polyline, _ellipse9, _path42, _path43, _path44, _path45, _path46, _path47, _g, _path48, _path49, _ellipse10, _line, _polyline2, _polyline3, _polyline4, _polyline5, _ellipse11, _ellipse12, _ellipse13, _path50, _path51, _path52, _line2, _path53, _path54, _circle, _circle2, _circle3, _path55, _path56, _path57, _circle4, _circle5, _path58, _ellipse14, _path59, _path60, _line3, _line4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenVaultClipart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 383.6 415.9",
    style: {
      enableBackground: "new 0 0 383.6 415.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#212552;}\n\t.st1{fill:#92D6E9;}\n\t\n\t\t.st2{opacity:0.3;fill:#0A1E2B;stroke:#0A1E2B;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st3{fill:none;stroke:#212552;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#CBEDF9;}\n\t.st5{fill:#E8F9FF;}\n\t\n\t\t.st6{opacity:0.23;fill:#0A1E2B;stroke:#0A1E2B;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st7{fill:#53ADBC;}\n\t.st8{fill:#5F9E71;stroke:#212552;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#90C49E;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:#A78B75;}\n\t.st12{fill:#FFE07D;}\n\t.st13{fill:#FFE8A6;}\n\t.st14{fill:#9FBDCA;stroke:#9FBDCA;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:#3CA4B5;}\n\t.st16{fill:none;stroke:#212552;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#212552;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FFEA9E;}\n\t\n\t\t.st19{opacity:0.23;fill:none;stroke:#0A1E2B;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_75_",
    className: "st0",
    cx: 182.6,
    cy: 393.1,
    rx: 182.6,
    ry: 22.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st1",
    d: "M142.1,377v-7.4c0-3.3-2.7-6-6-6h-66c-3.3,0-6,2.7-6,6v22c0,3.3,2.7,6,6,6H114 c4.8,0,9.4-1.9,12.8-5.3L142.1,377z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st2",
    d: "M136.1,363.6h-66c-3.3,0-6,2.7-6,6V390h65l13-13v-7.4C142.1,366.3,139.4,363.6,136.1,363.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st1",
    d: "M223.1,377v-7.4c0-3.3,2.7-6,6-6h66c3.3,0,6,2.7,6,6v22c0,3.3-2.7,6-6,6h-43.9 c-4.8,0-9.4-1.9-12.8-5.3L223.1,377z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st2",
    d: "M295.1,363.6h-66c-3.3,0-6,2.7-6,6v7.4l13,13h65v-20.4C301.1,366.3,298.4,363.6,295.1,363.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st3",
    d: "M142.1,377v-7.4c0-3.3-2.7-6-6-6h-66c-3.3,0-6,2.7-6,6v22c0,3.3,2.7,6,6,6H114 c4.8,0,9.4-1.9,12.8-5.3L142.1,377z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st3",
    d: "M223.1,377v-7.4c0-3.3,2.7-6,6-6h66c3.3,0,6,2.7,6,6v22c0,3.3-2.7,6-6,6h-43.9 c-4.8,0-9.4-1.9-12.8-5.3L223.1,377z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st4",
    d: "M312.6,377.1h-260c-22.1,0-40-17.9-40-40v-260c0-22.1,17.9-40,40-40h260c22.1,0,40,17.9,40,40 v260C352.6,359.2,334.7,377.1,312.6,377.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st5",
    d: "M312.6,37.1h-260c-22.1,0-40,17.9-40,40v23c0-22.1,17.9-40,40-40h260c22.1,0,40,17.9,40,40v-23 C352.6,55,334.7,37.1,312.6,37.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st1",
    d: "M312.6,354.1h-260c-22.1,0-40-17.9-40-40v23c0,22.1,17.9,40,40,40h260c22.1,0,40-17.9,40-40v-23 C352.6,336.2,334.7,354.1,312.6,354.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_143_",
    className: "st6",
    points: "51.3,336.2 87.7,377.1 155.7,377.1 199.6,376.8 190.9,311.7 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st1",
    d: "M64.6,341.1c-8.8,0-16-7.2-16-16v-236c0-8.8,7.2-16,16-16h236c8.8,0,16,7.2,16,16v236 c0,8.8-7.2,16-16,16H64.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    className: "st3",
    d: "M316.6,89.1v236c0,8.8-7.2,16-16,16h-236c-8.8,0-16-7.2-16-16v-236c0-8.8,7.2-16,16-16H192 c4.5,2.1,7.6,6.8,7.6,11.9v10.3h82.6c2.6,0,5,1.1,6.7,2.8l20.7-22.2C313.8,78.7,316.6,83.6,316.6,89.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_139_",
    className: "st6",
    points: "273.5,299.5 328.1,330.1 339.1,295.9 309.6,275.7 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st7",
    d: "M309.6,75.9l-20.7,22.2c-1.7-1.7-4.1-2.8-6.7-2.8h-82.6V85c0-5.1-3.2-9.8-7.6-11.9h108.6 C303.9,73.1,307.1,74.1,309.6,75.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    className: "st3",
    d: "M309.6,75.9l-20.7,22.2c-1.7-1.7-4.1-2.8-6.7-2.8h-82.6V85c0-5.1-3.2-9.8-7.6-11.9h108.6 C303.9,73.1,307.1,74.1,309.6,75.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_128_",
    className: "st3",
    d: "M288.9,98c1.7,1.7,2.8,4.1,2.8,6.7v198.9c0,5.8-4.7,10.4-10.4,10.4h-81.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st8",
    d: "M344.6,270.3l-18.1-46.9c-1-2.7-4.1-4-6.8-3l-44.3,17.2l-44.3,17.1c-2.7,1-4,4.1-3,6.8 l18.1,46.9c1,2.7,4.1,4,6.8,3l44.3-17.1l44.3-17.1C344.3,276,345.7,273,344.6,270.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st3",
    d: "M344.6,270.3l-18.1-46.9c-1-2.7-4.1-4-6.8-3l-44.3,17.2l-44.3,17.1c-2.7,1-4,4.1-3,6.8 l18.1,46.9c1,2.7,4.1,4,6.8,3l44.3-17.1l44.3-17.1C344.3,276,345.7,273,344.6,270.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    className: "st9",
    d: "M331.9,268l-4.7-12.1c-2.8,1.1-5.9-0.3-7-3.1s0.3-5.9,3.1-7l-4.7-12.1 c-0.6-1.4-2.2-2.2-3.6-1.6l-35.4,13.7l-0.8,0.3l-35.4,13.7c-1.4,0.6-2.2,2.2-1.6,3.6l4.7,12.1c2.8-1.1,5.9,0.3,7,3.1s-0.3,5.9-3.1,7 l4.7,12.1c0.6,1.4,2.2,2.2,3.6,1.6l35.4-13.7l0.8-0.3l35.4-13.7C331.7,271.1,332.4,269.5,331.9,268z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_56_",
    transform: "matrix(0.9327 -0.3606 0.3606 0.9327 -76.6213 121.1237)",
    className: "st10",
    cx: 286.3,
    cy: 265.9,
    rx: 12.7,
    ry: 13.3
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_140_",
    className: "st6",
    points: "264.5,275.7 300,228.1 298.6,181.6 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_123_",
    className: "st11",
    points: "242.4,279.6 226.5,279.6 232.7,302 235.6,309.5 "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    className: "st12",
    d: "M221.5,314.1h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C231.5,308.9,227.7,314.1,221.5,314.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st13",
    d: "M230.1,303.2l-4.9-19.6c-0.8-3.4-4.9-5.9-9.1-5.9h-22.5c-4.2,0-8.2,2.5-9.1,5.9l-0.1,0.5 c0.9-0.2,1.8-0.3,2.7-0.3h22.5c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6c0.4,1.6,0.4,3.2,0,4.6C228.5,312.9,231.3,308.3,230.1,303.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    className: "st3",
    d: "M221.5,314.1h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C231.5,308.9,227.7,314.1,221.5,314.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    className: "st12",
    d: "M196,277.7h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.4 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C206,272.5,202.2,277.7,196,277.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    className: "st3",
    d: "M196,277.7h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.4 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C206,272.5,202.2,277.7,196,277.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_122_",
    className: "st8",
    d: "M295.5,178.5l-47.1-17.6c-2.7-1-5.7,0.4-6.7,3.1l-16.6,44.5L208.5,253c-1,2.7,0.4,5.7,3.1,6.7 l47.1,17.6c2.7,1,5.7-0.4,6.7-3.1l16.6-44.5l16.6-44.5C299.6,182.5,298.2,179.5,295.5,178.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    className: "st9",
    d: "M285.3,186.5l-12.1-4.5c-1,2.8-4.2,4.2-7,3.2s-4.2-4.2-3.2-7l-12.1-4.5 c-1.5-0.5-3.1,0.2-3.6,1.6L234,210.9l-0.3,0.8l-13.3,35.6c-0.5,1.5,0.2,3.1,1.6,3.6l12.1,4.5c1-2.8,4.2-4.2,7-3.2s4.2,4.2,3.2,7 l12.1,4.5c1.5,0.5,3.1-0.2,3.6-1.6l13.3-35.6l0.3-0.8l13.3-35.6C287.5,188.7,286.8,187.1,285.3,186.5z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_119_",
    transform: "matrix(0.3497 -0.9369 0.9369 0.3497 -40.3961 379.895)",
    className: "st10",
    cx: 253.4,
    cy: 219,
    rx: 12.7,
    ry: 13.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st3",
    d: "M295.5,178.5l-47.1-17.6c-2.7-1-5.7,0.4-6.7,3.1l-16.6,44.5L208.5,253c-1,2.7,0.4,5.7,3.1,6.7 l47.1,17.6c2.7,1,5.7-0.4,6.7-3.1l16.6-44.5l16.6-44.5C299.6,182.5,298.2,179.5,295.5,178.5z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_54_",
    className: "st11",
    points: "220.4,244.2 200.9,243.3 206.6,263.1 213.6,274.1 "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    className: "st12",
    d: "M250.5,277.7h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C260.5,272.5,256.7,277.7,250.5,277.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_156_",
    className: "st13",
    d: "M259,266.8l-4.9-19.6c-0.8-3.4-4.9-5.9-9.1-5.9h-22.4c-4.2,0-8.2,2.5-9.1,5.9l-0.3,1.2 c1.2-0.4,2.4-0.7,3.7-0.7h22.5c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6c0.3,1.4,0.4,2.7,0.2,4C257.9,275.8,260.2,271.5,259,266.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_111_",
    className: "st3",
    d: "M250.5,277.7h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C260.5,272.5,256.7,277.7,250.5,277.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    className: "st12",
    d: "M224.8,241.3h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C234.7,236.1,231,241.3,224.8,241.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_160_",
    className: "st13",
    d: "M233.3,230.4l-4.9-19.6c-0.8-3.4-4.9-5.9-9.1-5.9h-22.5c-4.2,0-8.2,2.5-9.1,5.9v0.2 c1-0.3,2.1-0.5,3.2-0.5h22.5c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6c0.4,1.7,0.4,3.4-0.1,4.9C232,239.7,234.5,235.3,233.3,230.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    className: "st3",
    d: "M224.8,241.3h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C234.7,236.1,231,241.3,224.8,241.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    className: "st6",
    d: "M300.6,73.1H138.4l0,0l4.7,145.6H231l67.6-37.1l18-66.8V89.1C316.6,80.2,309.4,73.1,300.6,73.1 z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    className: "st12",
    d: "M277.5,314.1h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C287.5,308.9,283.7,314.1,277.5,314.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    className: "st13",
    d: "M286,303.2l-4.9-19.6c-0.8-3.4-4.9-5.9-9.1-5.9h-22.4c-4.2,0-8.2,2.5-9.1,5.9l-0.4,1.7 c1.1-0.4,2.3-0.6,3.5-0.6h22.5c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6c0.3,1.2,0.4,2.4,0.2,3.5C284.8,312.4,287.2,308,286,303.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st3",
    d: "M277.5,314.1h-33.3c-6.2,0-10-5.1-8.5-10.9l4.9-19.6c0.8-3.4,4.9-5.9,9.1-5.9h22.5 c4.2,0,8.2,2.5,9.1,5.9l4.9,19.6C287.5,308.9,283.7,314.1,277.5,314.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st1",
    d: "M61.5,328.1V85.9c0-9.1,5.1-17.4,11.4-18.7L153.8,51c8.1-1.6,14.7,5.6,14.7,16v280 c0,10.5-6.7,17.6-14.7,16l-80.9-16.2C66.6,345.6,61.5,337.2,61.5,328.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st3",
    d: "M61.5,328.1V85.9c0-9.1,5.1-17.4,11.4-18.7L153.8,51c8.1-1.6,14.7,5.6,14.7,16v280 c0,10.5-6.7,17.6-14.7,16l-80.9-16.2C66.6,345.6,61.5,337.2,61.5,328.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st4",
    d: "M48.6,325.1v-236c0-8.8,4.9-17.2,11.1-18.6l80.9-18.9c8.2-1.9,15.1,5,15.1,15.5v280 c0,10.5-6.8,17.4-15.1,15.5l-80.8-18.9C53.5,342.2,48.6,333.9,48.6,325.1z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_154_",
    className: "st1",
    d: "M140.6,346.5l-80.8-18.9c-6.2-1.5-11.1-9.8-11.1-18.6v16c0,8.8,4.9,17.2,11.1,18.6l80.8,18.9 c8.2,1.9,15.1-5,15.1-15.5v-16C155.7,341.6,148.8,348.5,140.6,346.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    className: "st5",
    d: "M140.6,51.6L59.8,70.5c-6.2,1.5-11.1,9.8-11.1,18.6v12c0-8.8,4.9-17.2,11.1-18.6l80.8-18.9 c8.2-1.9,15.1,5,15.1,15.5v-12C155.7,56.6,148.8,49.7,140.6,51.6z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_14_",
    className: "st0",
    cx: 143.1,
    cy: 125.4,
    rx: 4.7,
    ry: 10.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st3",
    d: "M48.6,325.1v-236c0-8.8,4.9-17.2,11.1-18.6l80.9-18.9c8.2-1.9,15.1,5,15.1,15.5v280 c0,10.5-6.8,17.4-15.1,15.5l-80.8-18.9C53.5,342.2,48.6,333.9,48.6,325.1z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_141_",
    className: "st14",
    cx: 98.2,
    cy: 214.2,
    rx: 27.9,
    ry: 54.6
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_145_",
    className: "st14",
    cx: 97.2,
    cy: 265.9,
    rx: 8.6,
    ry: 7.8
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_11_",
    className: "st4",
    cx: 99.4,
    cy: 207.6,
    rx: 29.8,
    ry: 55.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_12_",
    className: "st1",
    cx: 97.2,
    cy: 207.6,
    rx: 23.4,
    ry: 46
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_146_",
    className: "st6",
    points: "71.3,207.6 115.1,209.3 102.1,262.9 87.7,258.7 69.6,207.6 "
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_5_",
    className: "st3",
    cx: 99.4,
    cy: 207.6,
    rx: 29.8,
    ry: 55.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st6",
    d: "M48.6,169.6L48.6,169.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,166,53,169.6,48.6,169.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st6",
    d: "M48.6,300.1L48.6,300.1c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,296.5,53,300.1,48.6,300.1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st1",
    d: "M48.6,161.6L48.6,161.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,158,53,161.6,48.6,161.6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st1",
    d: "M48.6,292.6L48.6,292.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,289,53,292.6,48.6,292.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st3",
    d: "M48.6,161.6L48.6,161.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,158,53,161.6,48.6,161.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st3",
    d: "M48.6,292.6L48.6,292.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,289,53,292.6,48.6,292.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_22_",
    className: "st3",
    x1: 380.6,
    y1: 54.9,
    x2: 360.4,
    y2: 52.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_21_",
    className: "st3",
    x1: 332.5,
    y1: 23.2,
    x2: 329.5,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_16_",
    className: "st3",
    x1: 352.5,
    y1: 30.5,
    x2: 367,
    y2: 16
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st15",
    d: "M94,187.1H78.3v41.1H94c6.9,0,12.4-9.2,12.4-20.5S100.8,187.1,94,187.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st3",
    d: "M94,187.1H78.3v41.1H94c6.9,0,12.4-9.2,12.4-20.5S100.8,187.1,94,187.1z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_9_",
    className: "st16",
    cx: 94,
    cy: 207.6,
    rx: 12.4,
    ry: 20.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_8_",
    className: "st17",
    x1: 113.6,
    y1: 207.6,
    x2: 93.1,
    y2: 207.6
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_72_",
    className: "st3",
    points: "81.5,187.1 94,187.1 94,171 81.5,187.1 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_39_",
    className: "st0",
    points: "81.5,187.1 94,187.1 94,171 81.5,187.1 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_10_",
    className: "st0",
    points: "81.5,228.1 94,228.1 94,244.2 81.5,228.1 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_101_",
    className: "st3",
    points: "81.5,228.1 94,228.1 94,244.2 81.5,228.1 "
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_34_",
    className: "st18",
    cx: 78.3,
    cy: 207.6,
    rx: 12.4,
    ry: 20.5
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4_",
    className: "st12",
    cx: 77.3,
    cy: 207.6,
    rx: 6.1,
    ry: 10
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_37_",
    className: "st3",
    cx: 78.3,
    cy: 207.6,
    rx: 12.4,
    ry: 20.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    className: "st4",
    d: "M187.9,342.2l-20.3,2V69.9l20.3,2c6.5,0.6,11.7,6.5,11.7,13v244.2 C199.6,335.7,194.4,341.6,187.9,342.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    className: "st6",
    d: "M200.2,174.2v-28.6h-22.3v30.3h0.1c0,6.2,5,11.2,11.2,11.2c6.2,0,11.2-5,11.2-11.2 C200.4,175.3,200.3,174.8,200.2,174.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    className: "st3",
    d: "M199.6,84.9v244.2c0,5.1-3.1,9.8-7.4,11.9c-1.2,0.6-2.6,1-4,1.1l-19.6,2V69.9l19.6,2 c1.4,0.1,2.7,0.5,4,1.1C196.5,75.2,199.6,79.8,199.6,84.9z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_107_",
    className: "st3",
    x1: 287.9,
    y1: 311.7,
    x2: 312.1,
    y2: 336.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_102_",
    className: "st1",
    d: "M189.5,132.4c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2h10.9v-22.3h-10.9V132.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    className: "st3",
    d: "M189.5,132.4c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2h10.9v-22.3h-10.9V132.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_104_",
    className: "st4",
    cx: 200.4,
    cy: 143.6,
    r: 11.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_32_",
    className: "st3",
    cx: 200.4,
    cy: 143.6,
    r: 11.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_124_",
    className: "st3",
    cx: 200.4,
    cy: 143.6,
    r: 11.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_136_",
    className: "st6",
    d: "M200.2,301.9v-28.6h-22.3v30.3h0.1c0,6.2,5,11.2,11.2,11.2c6.2,0,11.2-5,11.2-11.2 C200.4,303,200.3,302.4,200.2,301.9z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    className: "st1",
    d: "M189.5,260.1c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2h10.9v-22.3h-10.9V260.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    className: "st3",
    d: "M189.5,260.1c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2h10.9v-22.3h-10.9V260.1z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_129_",
    className: "st4",
    cx: 200.4,
    cy: 271.2,
    r: 11.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_127_",
    className: "st3",
    cx: 200.4,
    cy: 271.2,
    r: 11.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    className: "st1",
    d: "M133.6,279.9c-2.2,0-4-1.8-4-4v-142c0-2.2,1.8-4,4-4h8.2v-9h-9.2c-6.6,0-12,5.4-12,12v144 c0,6.6,5.4,12,12,12h9.2v-9H133.6z"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_137_",
    className: "st0",
    cx: 143.1,
    cy: 283.7,
    rx: 4.7,
    ry: 10.6
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st3",
    d: "M133.6,279.9c-2.2,0-4-1.8-4-4v-142c0-2.2,1.8-4,4-4h8.2v-9h-9.2c-6.6,0-12,5.4-12,12v144 c0,6.6,5.4,12,12,12h9.2v-9H133.6z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st3",
    d: "M312.6,377.1h-260c-22.1,0-40-17.9-40-40v-260c0-22.1,17.9-40,40-40h260c22.1,0,40,17.9,40,40 v260C352.6,359.2,334.7,377.1,312.6,377.1z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_144_",
    className: "st19",
    x1: 142.1,
    y1: 134.1,
    x2: 143.1,
    y2: 311.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_148_",
    className: "st3",
    x1: 141.2,
    y1: 51.3,
    x2: 156.7,
    y2: 50.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_149_",
    className: "st3",
    x1: 142.6,
    y1: 362.8,
    x2: 156.9,
    y2: 363.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenVaultClipart);
export default __webpack_public_path__ + "static/media/open-vault-clipart.74af9c774c9528abc049329922bd9dfc.svg";
export { ForwardRef as ReactComponent };